module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"officePictures":"Office photos","photo":"0 photos | {n} photo | {n} photos | {n} photos"}}')
  delete Component.options._Ctor
}
